import { mutatorAction } from 'satcheljs';
import EditorViewState from '../store/schema/EditorViewState';

const setCachedContent = mutatorAction(
    'SetCachedContent',
    (viewState: EditorViewState, contentWithSelection: string) => {
        // If a valid content is passed in, use it.
        // Otherwise it means we want to clear existing cache, so set both cached contents to null.
        // This will cause next time when we call focus() to editor, it won't resume the selection.
        viewState.cachedContent = contentWithSelection === null ? null : viewState.content;
        viewState.cachedContentWithSelection = contentWithSelection;
    }
);

export default setCachedContent;
